import { FormArray, FormGroup } from '@angular/forms';

import { Partner } from '@app/shared/_models/common';

// Mêmes refus que QuotationComponent.orderBlockedReason pour un contrat de location.
export function rentalSaveBlockedReason(fg: FormGroup | null, customer: Partner | null | undefined): string | null {
  if (!(Number(customer?.id) > 0)) return 'Un contrat de location ne peut être ni enregistré ni validé sans client : choisissez-en un';
  if (!fg?.get('addr_deliv')?.value) {
    return fg?.get('data')?.value?.recipient
      ? "Le tiers bénéficiaire n'a aucune adresse de livraison : complétez sa fiche avant d'enregistrer le contrat de location"
      : "Ce client n'a aucune adresse de livraison : complétez sa fiche avant d'enregistrer le contrat de location";
  }
  return null;
}

// Ce qu'un autre poste a pu changer sur une ligne et que le geste suppose : patient, article, quantité, nature, data (dates vérifiées…).
const lineMark = (l: any): string => JSON.stringify([String(l?.memo ?? '').trim(), Number(l?.product) || 0, Number(l?.qty) || 0, l?.typ ?? '', l?.data ?? null]);

// Audit 31/10 #8 : ligne visée retrouvée par son id dans la pièce relue ; disparue ou changée depuis l'affichage, le geste est refusé avec ce motif.
export function freshLine(fg: FormGroup, seen: any): FormGroup | string {
  const id = Number(seen?.id) || 0;
  const line = ((fg.get('lines') as FormArray | null)?.controls ?? []).find((c) => (Number(c.get('id')?.value) || 0) === id) as FormGroup | undefined;
  const what = `La ligne n° ${seen?.seq ?? id} (${seen?.product_name || 'matériel'})`;
  if (!id || !line) return `${what} n'est plus parmi les matériels en cours du dossier : retirée ou reprise depuis un autre poste. La page est rechargée.`;
  if (lineMark(line.getRawValue()) !== lineMark(seen)) return `${what} a été modifiée depuis un autre poste. La page est rechargée : refaites votre geste sur la ligne à jour.`;
  return line;
}

// Ajustements de QuotationComponent._executeSubmit avant l'UPDATE ; data (recipient compris) repart telle que lue.
export function prepareRentalSave(fg: FormGroup, customerId: number | null | undefined, store: number): void {
  if (customerId) fg.get('customer')?.setValue(customerId);
  const addrDeliv = fg.get('addr_deliv')?.value;
  const addrBill = fg.get('addr_bill')?.value;
  fg.patchValue({ addr_deliv: addrDeliv ? Number(addrDeliv) : 0, addr_bill: addrBill ? Number(addrBill) : 0, store });
  if (fg.get('addr_bill')?.disabled) fg.get('addr_bill')?.enable({ emitEvent: false });
  if (fg.get('addr_deliv')?.disabled) fg.get('addr_deliv')?.enable({ emitEvent: false });
}
